/**
 * winds-novelty.js — ノベルティ自動追加
 *
 * 配送が必要な商品(ノベルティ自身を除く)の合計が、税込・カート上の割引適用後で
 * しきい値以上のとき、ノベルティを必ず1個だけカートに入れる。未満になったら削除する。
 *
 * 設定は snippets/winds-novelty-config2.liquid が window.WindsNoveltyConfig として注入する。
 * 有効/無効(カスタマータグ判定)も Liquid 側で決定される。
 *
 * purge: 無効(enabled=false)でも purge=true なら「削除のみ」動作する。
 * ゲスト時に入ったノベルティが問屋タグでのログイン後に残る問題への対処(2026-07-24)。
 *
 * 注意: カートAJAX APIの金額は JPY でも100倍の整数(¥10,000 → 1000000)。
 */
(function () {
  var cfg = window.WindsNoveltyConfig;
  if (!cfg || !cfg.variantId || !cfg.threshold) return;

  var purgeOnly = !cfg.enabled;
  if (purgeOnly && !cfg.purge) return;

  var VARIANT_ID = cfg.variantId;
  var THRESHOLD = cfg.threshold;

  var syncing = false; // 自分のカート操作中(再帰防止)
  var queued = false;  // 同期中に再要求が来たらもう一度実行
  var timer = null;
  var lastFailedSig = ''; // 失敗したアクションの署名。同じカート状態への同じ操作は再試行しない
                          // (例: 取り寄せ商品との同時購入制限で追加が常に422になるカート)

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 350);
  }

  function run() {
    if (syncing) { queued = true; return; }
    syncing = true;
    sync()
      .catch(function () { /* 在庫切れ(422)や通信エラーは購入フローを妨げない */ })
      .then(function () {
        syncing = false;
        if (queued) { queued = false; schedule(); }
      });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart api ' + r.status);
      return r.json();
    });
  }

  function sync() {
    return getCart().then(function (cart) {
      var shippableTotal = 0;
      var novelty = null;
      (cart.items || []).forEach(function (item) {
        if (item.variant_id === VARIANT_ID) { novelty = item; return; } // ノベルティは判定から除外
        if (item.requires_shipping) shippableTotal += item.final_line_price;
      });

      var action = null;
      var request = null;
      if (purgeOnly) {
        if (novelty) {
          action = 'remove';
          request = function () { return postCart('/cart/change.js', { id: novelty.key, quantity: 0 }); };
        }
      } else if (shippableTotal >= THRESHOLD) {
        if (!novelty) {
          action = 'add';
          request = function () { return postCart('/cart/add.js', { items: [{ id: VARIANT_ID, quantity: 1 }] }); };
        } else if (novelty.quantity !== 1) {
          action = 'fix-qty';
          request = function () { return postCart('/cart/change.js', { id: novelty.key, quantity: 1 }); };
        }
      } else if (novelty) {
        action = 'remove';
        request = function () { return postCart('/cart/change.js', { id: novelty.key, quantity: 0 }); };
      }

      if (!request) { lastFailedSig = ''; return; }

      // 同一カート状態で一度失敗した操作はカートが変化するまで再試行しない(422/429の連打防止)
      var sig = action + '|' + (cart.items || []).map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
      if (sig === lastFailedSig) return;

      return request().then(function () {
        lastFailedSig = '';
        return refreshUI();
      }, function () {
        lastFailedSig = sig;
      });
    });
  }

  // Impulse テーマのカートUI(カートページ/ドロワー)を再描画させる
  function refreshUI() {
    return getCart().then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    });
  }

  // ---- トリガー ----

  // 1) ページ表示時
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // 2) テーマが発火するカートイベント
  document.addEventListener('ajaxProduct:added', schedule);
  document.addEventListener('cart:updated', schedule);

  // 2.5) ポーリング(他アプリが fetch を上書きしてインターセプトが外れても確実に同期する)
  setInterval(schedule, 10000);

  // 3) カートを変更する fetch/XHR を捕捉(テーマ・アプリ両対応)
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var fromSelf = syncing;
    var p = origFetch.apply(this, arguments);
    if (!fromSelf && CART_RE.test(url)) p.then(schedule, function () {});
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!syncing && typeof url === 'string' && CART_RE.test(url)) {
      this.addEventListener('loadend', schedule);
    }
    return origOpen.apply(this, arguments);
  };
})();
